import { useParams, useNavigate } from 'react-router-dom'
import { SubmitHandler } from 'react-hook-form'

import { AssignmentForm } from '@containers/Forms/Assignment'
import { TAssignmentForm } from '@containers/Forms/Assignment/schema'
import { useAlerts } from '@hooks/alerts'
import { useFindTask } from '@hooks/task/find'
import { useUpdateTaskResource } from '@hooks/task/put/editResource'
import { IGenericAssignment } from '@interfaces/task/generic/IGenericAssignment'

export function EditAssignmentFormScreen() {
  const { showDeleteAlert, showDismissAlert } = useAlerts()

  const { assignmentId: assignmentIdParam, taskId: taskIdParam } = useParams<{ assignmentId: string; taskId: string }>()
  const assignmentId = Number(assignmentIdParam)
  const taskId = Number(taskIdParam)
  const navigate = useNavigate()

  const { data: rawTask } = useFindTask(taskId)

  const { mutateAsync: putTask } = useUpdateTaskResource()
  const task = rawTask ?? ({} as NonNullable<typeof rawTask>)

  const handleSave: SubmitHandler<TAssignmentForm> = async (
    data: TAssignmentForm,
  ) => {
    const assignments = task.assignments.map((asg) => {
      if (asg.id === assignmentId) {
        return {
          ...asg,
          ...data,
        }
      }
      return asg
    })

    const payload = {
      id: task.id,
      task: {
        ...task,
        assignments,
      },
    }

    try {
      await putTask(payload)
      navigate(-1)
    } catch {
      window.alert('Error\n\nFailed to save resource. Please try again.')
    }
  }

  const assignment =
    task.assignments.find(({ id }) => id === assignmentId) ??
    ({} as IGenericAssignment)

  function handleShowAlertForDeleteResource() {
    showDeleteAlert('Resource', deleteResource)
  }

  const deleteResource = async () => {
    const assignments = task.assignments.map((asg) => {
      if (asg.id === assignmentId) {
        asg = {
          ...asg,
          wasDeleted: true,
        }
      }

      return asg
    })

    const payload = {
      id: task.id,
      task: {
        ...task,
        assignments,
      },
    }

    try {
      await putTask(payload)
      navigate(-1)
    } catch {
      window.alert('Error\n\nFailed to delete resource. Please try again.')
    }
  }

  function handleShowAlertOnAssignmentDismiss() {
    showDismissAlert(() => navigate(-1))
  }

  return (
    <AssignmentForm
      onSave={handleSave}
      onDelete={handleShowAlertForDeleteResource}
      onClose={handleShowAlertOnAssignmentDismiss}
      assignment={assignment}
      task={task}
      title="Edit Resource"
    />
  )
}
